import { render, staticRenderFns } from "./QuestionnaireReviewForm.vue?vue&type=template&id=af5c3b40&scoped=true&"
import script from "./QuestionnaireReviewForm.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireReviewForm.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireReviewForm.vue?vue&type=style&index=0&id=af5c3b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5c3b40",
  null
  
)

export default component.exports